import React, { useState, useEffect } from 'react';
import TeacherCard from '../common/TeacherCard';
import { getAllTeachers } from '../../services/api';

const TeacherSection = () => {
  const [teachers, setTeachers] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await getAllTeachers();
        if (response && response.data) {
          // Split teaching_method by commas for each teacher
          const teachersWithMethods = response.data.map(teacher => ({
            ...teacher,
            teaching_method: teacher.teaching_method ? teacher.teaching_method.split(',').map(m => m.trim()) : []
          }));
          setTeachers(teachersWithMethods);
        }
      } catch (error) {
        console.error('Error fetching teachers:', error);
      }
    };
    fetchTeachers();
  }, []);

  const totalPages = Math.ceil(teachers.length / itemsPerPage);

  // Get current page teachers
  const currentTeachers = teachers.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePrev = () => {
    setPage(prev => (prev === 1 ? totalPages : prev - 1));
  };

  const handleNext = () => {
    setPage(prev => (prev === totalPages ? 1 : prev + 1));
  };

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Đội Ngũ Giáo Viên <span className="text-primary-600">Đầy Nhiệt Huyết Và Tâm Huyết</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Giới chuyên môn - Giàu kinh nghiệm - Luôn đổi mới
          </p>
        </div>

        {/* Teachers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition duration-500 ease-in-out">
          {currentTeachers.map((teacher) => (
            <TeacherCard key={teacher.id} teacher={teacher} />
          ))}
        </div>

        {/* Navigation Arrows */}
        <div className="flex justify-center mt-12 space-x-4">
          <button
            onClick={handlePrev}
            className="p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={handleNext}
            className="p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeacherSection;
